import React from "react";

export function WB_CoreHeaderTwo({}) {
    return <div className="prose prose-base">
        <h2>Header Two</h2>
    </div>
}